var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brands"},[_c('header',{staticClass:"main-header",style:({ backgroundImage: ("url(" + (require('@/assets/img/brands/header.png')) + ")") })},[_c('h1',[_vm._v(_vm._s(_vm.$t('brands.title')))])]),_c('TheProducts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }